module.exports = __webpack_public_path__ + "static/img/avatar-woman.1555f65f.png";